var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplementalArrowHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 6,
    viewBox: "0 0 31 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 3L26 .113v5.774L31 3zM0 3l5 2.887V.113L0 3zm30.031-.5a.5.5 0 100 1v-1zm-1.937 1a.5.5 0 000-1v1zm-1.938-1a.5.5 0 000 1v-1zm-1.937 1a.5.5 0 000-1v1zm-1.938-1a.5.5 0 000 1v-1zm-1.937 1a.5.5 0 000-1v1zm-1.938-1a.5.5 0 000 1v-1zm-1.937 1a.5.5 0 000-1v1zm-1.938-1a.5.5 0 000 1v-1zm-1.937 1a.5.5 0 000-1v1zm-1.938-1a.5.5 0 000 1v-1zm-1.937 1a.5.5 0 000-1v1zm-1.938-1a.5.5 0 100 1v-1zm-1.937 1a.5.5 0 000-1v1zm-1.938-1a.5.5 0 100 1v-1zM.97 3.5a.5.5 0 000-1v1zm27.125-1h-1.938v1h1.938v-1zm-3.875 0H22.28v1h1.938v-1zm-3.875 0h-1.938v1h1.938v-1zm-3.875 0H14.53v1h1.938v-1zm-3.875 0h-1.938v1h1.938v-1zm-3.875 0H6.78v1H8.72v-1zm-3.875 0H2.906v1h1.938v-1z",
    fill: "#FFBF00"
  })));
}
export default SvgSupplementalArrowHistory;